<div class="pr-20 pl-20 display-flex flex-align-center full-height justify-content">
  <div>
    <div class="label" [ngStyle]="{ backgroundColor: adloopRating.color }">
      {{ adloopRating.value | translate }}
    </div>
  </div>
</div>
